export default "__VITE_PUBLIC_ASSET__079a51ae__"